'use client'
import ProductVariantTextBoxesNew from './product-variant-text-boxes-new'
import ProductVariantImageCards from './product-variant-image-cards'
import UnavailableVariantModal from './variant-modal'
import { useState } from 'react'
import { ProductVariantKind } from '@productsite-beta/src/graphql/generated/graphql-types'
import { ProductForPageFragment } from '@productsite-beta/src/graphql/generated/graphql-types'

type Props = {
  mainProduct: ProductForPageFragment
  forwardRef?: any
}
export type ProductVariant = NonNullable<
  ProductForPageFragment['variants']
>['variantsInformation'][0]

export default function ListVariantGroups({ mainProduct }: { mainProduct: Props['mainProduct'] }) {
  const [missingVariantNames, setMissingVariantNames] = useState([''])
  const [showDialog, setShowDialog] = useState(false)
  const [modalConfirmUrl, setModalConfirmUrl] = useState('')

  function handleOnClick(missingVariantNames: string[], confirmUrl: string) {
    setMissingVariantNames(missingVariantNames)
    setModalConfirmUrl(confirmUrl)
    setShowDialog(true)
  }

  let variantList: (ProductVariant | null)[] = mainProduct.variants?.variantsInformation || []
  variantList = variantList
    ?.map(vCategory => {
      if (vCategory) {
        const filteredValues = vCategory?.values.filter(
          v => v.product?.availability?.isAvailableForSale && v.productVariantCombinationExists
        )
        if (filteredValues.length <= 1) return null
        vCategory['values'] = filteredValues
        return vCategory
      }
      return null
    })
    .filter(v => v)

  return (
    <>
      {variantList?.map(
        (variantGroup, i) =>
          variantGroup &&
          variantGroup.values.length > 1 && (
            <ol key={variantGroup.variantName + i} className="c-product-variant__selection-group">
              {variantGroup.kind === ProductVariantKind.ProductImage && (
                <ProductVariantImageCards
                  mainProduct={mainProduct}
                  variantName={variantGroup.variantName}
                  variantNameEng={variantGroup.variantNameEng}
                  variantValues={variantGroup.values}
                  onClick={handleOnClick}
                />
              )}
              {variantGroup.kind === ProductVariantKind.Text && (
                <ProductVariantTextBoxesNew
                  variantName={variantGroup.variantName}
                  variantNameEng={variantGroup.variantNameEng}
                  variantValues={variantGroup.values}
                  mainProduct={mainProduct}
                  onClick={handleOnClick}
                />
              )}
              {variantGroup.kind === ProductVariantKind.Boolean && (
                <ProductVariantTextBoxesNew
                  variantName={variantGroup.variantName}
                  variantNameEng={variantGroup.variantNameEng}
                  variantValues={variantGroup.values}
                  mainProduct={mainProduct}
                  onClick={handleOnClick}
                />
              )}
            </ol>
          )
      )}
      <UnavailableVariantModal
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        missingVariantNames={missingVariantNames}
        confirmUrl={modalConfirmUrl}
      />
    </>
  )
}
